module.exports = __webpack_public_path__ + "img/import-icon.2e44ba70.svg";